module.exports = __webpack_public_path__ + "static/media/PZ_Data_Protection_Notice_Common_V2.3_15122023.9903c242.pdf";